import { Component, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { IAbstractView } from '@core/interfaces';
import { ButtonPresenter } from './button.presenter';
import { IButtonComponent, IButtonPresenter } from './interfaces';
import { IconComponent } from '../icon/icon.component';

@Component({
	selector: 'app-button',
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
	imports: [CommonModule, IonicModule, IconComponent],
	providers: [ButtonPresenter],
	standalone: true,
})
export class ButtonComponent extends IAbstractView<IButtonPresenter> implements IButtonComponent {
	translations = this.presenter.translations;
	buttonClassSignal = this.presenter.buttonClassSignal;

	@Input() loading$ = this.presenter.loading$;
	@Input() text = this.presenter.text;
	@Input({ required: true }) type = this.presenter.type;
	@Input() icon = this.presenter.icon;
	@Input() disabled = this.presenter.disabled;
	@Output() buttonClicked = this.presenter.buttonClicked;

	constructor(presenter: ButtonPresenter) {
		super(presenter);
	}

	onClick(): void {
		this.presenter.onClick();
	}
}
